import React from "react";
import { Navigation } from "../components/Navigation";
import { COPY } from "../constants/copy";

interface ForeverSectionProps {
  onNext: () => void;
  onPrevious: () => void;
}

export const ForeverSection: React.FC<ForeverSectionProps> = ({
  onNext,
  onPrevious,
}) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-warmWhite dark:bg-darkBg transition-colors duration-400 py-20">
      <div className="max-w-2xl text-center space-y-12">
        <div className="animate-fade-in space-y-8">
          {/* Decorative divider */}
          <div className="flex items-center justify-center gap-4">
            <div className="h-px w-8 bg-gradient-to-r from-transparent to-heartRed dark:to-softRose"></div>
            <span className="text-heartRed dark:text-softRose text-2xl">❤</span>
            <div className="h-px w-8 bg-gradient-to-l from-transparent to-heartRed dark:to-softRose"></div>
          </div>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl font-light text-deepCharcoal dark:text-darkText leading-tight whitespace-pre-line">
            {COPY.forever.heading}
          </h2>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-heartRed dark:text-softRose font-light">
            {COPY.forever.subtext}
          </p>
        </div>

        {/* Dividing line */}
        <div className="h-px w-16 bg-softRose dark:bg-gray-700 mx-auto"></div>

        {/* Supporting message */}
        <div className="space-y-3 text-mutedGray dark:text-gray-400 font-light text-sm">
          <p>What we started 60 days ago</p>
          <p>is still beginning.</p>
        </div>

        <Navigation
          onNext={onNext}
          onPrevious={onPrevious}
          nextLabel={COPY.forever.button}
          showPrevious={true}
        />
      </div>
    </div>
  );
};
